export default __webpack_public_path__ + "static/media/Camerron-2.19389300.png";